<template>
    <div class="wrapper">
        <h1 class="crumb">物流公司列表</h1>
        <div class="bar">
            <div class="btnGroup">
                <el-button class="btn" @click="addTeam">物流公司列表</el-button>
            </div>
        </div>
        <el-table
            :data="tableData"
            style="width: 100%">
            <el-table-column label="安装队名" prop="team_name" align="center"></el-table-column>
            <el-table-column label="队长名" prop="leader_name" align="center" show-overflow-tooltip="true"></el-table-column>
            <el-table-column label="队长电话" prop="leader_tel" align="center" ></el-table-column>
            <el-table-column label="登录帐号" prop="login_account" align="center"></el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="props">
                    <a @click="EditInsTeam(props.row)">编辑</a><span> | </span><a @click="Delete(props.row)">删除</a>
                </template>
            </el-table-column>
        </el-table>
        <!--安装队列表-->
        <el-dialog :visible.sync="addInsTeam" :rules="rules"
                   title="添加安装队">
            <el-form ref="forms" :rules="rules" :model="formData" style="padding: 30px" label-width="120px">
                <el-form-item label="安装队名：" prop="team_name">
                    <el-input v-model="formData.team_name" placeholder="请输入安装队名字"></el-input>
                </el-form-item>
                <el-form-item label="队长名：" prop="leader_name" >
                    <el-input  placeholder="请输入队长名字" v-model="formData.leader_name"></el-input>
                </el-form-item>
                <el-form-item label="队长电话：" prop="leader_tel">
                    <el-input v-model="formData.leader_tel" placeholder="请输入队长电话"></el-input>
                </el-form-item>
                <el-form-item label="登录帐号：" prop="login_account">
                    <el-input v-model="formData.login_account" placeholder="请输入登录帐号"></el-input>
                </el-form-item>
                <el-form-item label="登录密码：" prop="login_password">
                    <el-input v-model="formData.login_password" placeholder="请输入登录密码"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addInsTeam = false">取 消</el-button>
                <el-button type="primary" @click="Add">确 定</el-button>
            </span>
        </el-dialog>
        <!--编辑安装队-->
        <el-dialog :visible.sync="editTeam" :rules="rule"
                   title="编辑安装队">
            <el-form ref="form" :rules="rule" :model="editForm" style="padding: 30px" label-width="120px">
                <el-form-item label="安装队名：" prop="team_name">
                    <el-input v-model="editForm.team_name" placeholder="请输入安装队名字"></el-input>
                </el-form-item>
                <el-form-item label="队长名：" prop="leader_name" >
                    <el-input  placeholder="请输入队长名字" v-model="editForm.leader_name"></el-input>
                </el-form-item>
                <el-form-item label="队长电话：" prop="leader_tel">
                    <el-input v-model="editForm.leader_tel" placeholder="请输入队长电话"></el-input>
                </el-form-item>
                <el-form-item label="登录帐号：" prop="login_account">
                    <el-input v-model="editForm.login_account" placeholder="请输入登录帐号"></el-input>
                </el-form-item>
                <el-form-item label="登录密码：" prop="login_password">
                    <el-input v-model="editForm.login_password" placeholder="修改密码时才填(可不传)"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editTeam = false">取 消</el-button>
                <el-button type="primary" @click="Edit">确 定</el-button>
            </span>
        </el-dialog>
    </div>

</template>

<script>
    import {getInsTeamList, AddTeam, EditTeam, DeleteTeam} from '../stores/api'
    export default {
        data() {
            return {
                tableData: [],
                addInsTeam: false,
                editTeam: false,
                formData: {
                    leader_name: '',
                    leader_tel: '',
                    login_account: '',
                    login_password: '',
                    team_name: ''
                },
                editForm: {
                    leader_name: '',
                    leader_tel: '',
                    login_account: '',
                    login_password: '',
                    team_name: '',
                    team_id: '',
                },
                rules: {
                    leader_name: [{required: true, message: '请输入队长名字', trigger: 'blur'}],
                    leader_tel: [{required: true, message: '请输入队长电话', trigger: 'blur'}],
                    login_account: [{required: true, message: '请输入登录账号', trigger: 'blur'}],
                    login_password: [{required: true, message: '请输入登录密码', trigger: 'blur'}],
                    team_name: [{required: true, message: '请输入安装对名字', trigger: 'blur'}]
                },
                rule: {
                    leader_name: [{required: true, message: '请输入队长名字', trigger: 'blur'}],
                    leader_tel: [{required: true, message: '请输入队长电话', trigger: 'blur'}],
                    login_account: [{required: true, message: '请输入登录账号', trigger: 'blur'}],
                    team_name: [{required: true, message: '请输入安装对名字', trigger: 'blur'}]
                }
            }
        },
        created() {
            this.getList()
        },
        methods: {
            getList() {
                getInsTeamList().then(res => {
                    console.log(res.data)
                    this.tableData = res.data.team_list
                })
            },
            addTeam() {
                this.addInsTeam = true
            },
            Add() {
                this.$refs.forms.validate(async (valid) => {
                    if (valid) {
                        AddTeam(this.formData.team_name, this.formData.leader_name, this.formData.leader_tel, this.formData.login_account, this.formData.login_password).then(res => {
                            if (res.data.error === 0) {
                                this.$message.success(res.data.msg)
                                this.getList()
                                this.addInsTeam = false
                            }
                        })
                    }
                })
            },
            EditInsTeam(row) {
                this.editTeam = true
                this.editForm.team_name = row.team_name
                this.editForm.leader_name = row.leader_name
                this.editForm.leader_tel = row.leader_tel
                this.editForm.login_account = row.login_account
                this.editForm.team_id = row.team_id
                this.editForm.login_password = ''
            },
            Edit() {
                this.$refs.form.validate(async (valid) => {
                    if (valid) {
                        EditTeam(this.editForm).then(res => {
                            this.getList()
                            this.editTeam = false
                            this.$message.success(res.data.msg)
                        })
                    }
                })
            },
            Delete(row) {
                let team_id = row.team_id
                DeleteTeam(team_id).then(res => {
                    if (res.data.error === 0) {
                        this.$message.success('删除成功')
                        this.getList()
                    }
                }).catch(err => {
                    console.log(err)
                })
            }
        }
    }
</script>
<style lang="less" scoped>
    .wrapper{
        .bar {
            display: flex;
            justify-content: space-between;
            margin-bottom: 15px;
            .btnGroup {
                button {
                    width: 100Px;
                    height: 35Px;
                    margin-right: 10Px;
                    font-size: 16px;
                    color: #ffffff;
                    background: #f56c31;
                    border-radius: 2px;
                }
            }
        }
    }
    .dia_form{
        .el-form-item__label{
            width: 25%;
            text-align: right;
        }
        .el-input{
            width: 55%;
        }
    }
    .el-table th>.cell{
        color:#ea6625;
    }
    .demo-table-expand {
        font-size: 0;
    }
    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }
    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }

</style>
<style>
    .el-table th>.cell{
        color:#ea6625;
    }
</style>



// WEBPACK FOOTER //
// src/router/LogisticsCompany.vue